import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo.png";

export function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-3 sm:px-4 pt-3">
      <nav className="container mx-auto max-w-5xl">
        <div className="flex items-center justify-between bg-card/70 backdrop-blur-2xl border border-border/40 rounded-2xl px-5 py-2.5 shadow-lg">
          <Link to="/" className="flex items-center gap-2.5">
            <img src={logo} alt="Memo" className="h-9 w-9 rounded-xl" />
            <span className="text-lg font-semibold text-foreground">Memo</span>
          </Link>

          <button
            className="md:hidden p-2 text-muted-foreground hover:text-foreground transition-colors"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/pricing"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Pricing
            </Link>
            <Link
              to="/how-it-works"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              How it works
            </Link>
            <Link to="/auth">
              <Button
                size="sm"
                className="bg-accent hover:bg-accent/90 text-accent-foreground rounded-full px-5"
              >
                Start your Memo
              </Button>
            </Link>
          </div>
        </div>

        {open && (
          <div className="md:hidden mt-2 bg-card/95 backdrop-blur-2xl border border-border/40 rounded-2xl px-5 py-4 space-y-3 shadow-lg">
            <Link
              to="/pricing"
              className="block text-sm font-medium text-muted-foreground hover:text-foreground"
              onClick={() => setOpen(false)}
            >
              Pricing
            </Link>
            <Link
              to="/how-it-works"
              className="block text-sm font-medium text-muted-foreground hover:text-foreground"
              onClick={() => setOpen(false)}
            >
              How it works
            </Link>
            <Link to="/auth" onClick={() => setOpen(false)}>
              <Button
                size="sm"
                className="w-full bg-accent hover:bg-accent/90 text-accent-foreground rounded-full"
              >
                Start your Memo
              </Button>
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}
